import Axios from 'axios'
import config from '../config'
import {
  activeAccessToken,
  clearRefreshTokenAndSession,
  getActiveRefreshToken,
  setActiveAccessToken,
} from './AuthorizationHelpers'
import userManager from './UserManager'
import { loadLocale } from './utils'

export const axios = Axios.create({
  baseURL: config.api.url,
  headers: {
    'Accept-Language': loadLocale(),
  },
  validateStatus: status => {
    if (status >= 200 && status < 300) return true
    if (status === 401) return true

    return false
  },
})

axios.interceptors.request.use(
  async req => {
    if (!req.headers.Public) {
      const refreshToken = getActiveRefreshToken()
      if (!refreshToken) return req

      const { exp, token } = activeAccessToken

      if (!token || !exp || Date.now() >= exp) {
        try {
          const newUserDetails = await userManager.renewToken()
          setActiveAccessToken(newUserDetails.access_token, newUserDetails.expires_at)
        } catch (e) {
          await clearRefreshTokenAndSession()
          return req
        }
      }
      req.headers['Authorization'] = `Bearer ${activeAccessToken.token}`
    }
    return req
  },
  err => Promise.reject(err),
)

axios.interceptors.response.use(async response => {
  if (response.status == 401) {
    const newUserDetails = await userManager.renewToken()
    setActiveAccessToken(newUserDetails.access_token, newUserDetails.expires_at)
    axios.defaults.headers['Authorization'] = `Bearer ${activeAccessToken.token}`
    response.config.headers['Authorization'] = `Bearer ${activeAccessToken.token}`
    axios(response.config)
  }
  return response
})
